<script>
	import {Doughnut, mixins as doughnutMixins} from 'vue-chartjs'
    const {reactiveProp} = doughnutMixins;
	export default {
		extends: Doughnut,
		name: "DoughnutChart",
        mixins: [reactiveProp],
		props: {
			// chartdata: {
			// 	required: true,
			// 	type: Object,
			// 	default: null
			// },
			options: {
				type: Object,
				default: null
			}
		},
		data() {
			return {
				htmlLegend: ""
			}
		},
		mounted() {
			this.renderChart(this.chartData, this.options);
			this.htmlLegend = this.generateLegend();
			this.$emit("generated", this.htmlLegend);
		}
	}
</script>

<style scoped>

</style>
